import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IStoreCostKindsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IStoreCostKindsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.storeCostKinds");

export const storeCostKinds = {
  ...getAllApis,
};
